<form 
    (ngSubmit)="$event.preventDefault(); saveThreatAssessmentInfo();"
    class="w-full h-full flex flex-col items-center justify-start gap-4 overflow-y-auto"
    [formGroup]="threatAssessInfoForm"
>
    <div class="w-full overflow-y-auto px-1">                    
        <h2 class="pb-2 w-full oswald-font text-xl font-medium text-start">
            Threat Assessment Info
        </h2>
        <div class="w-full flex flex-col items-center gap-2 pb-4"> 
            <div class="w-full flex flex-col items-center text-start">
                <div class="w-full font-semibold mb-2">
                    <p>Person(s) Participating in Assessment Process: </p>
                </div>
                <div class="w-full flex flex-col items-start gap-2">
                    <div class="w-full flex flex-col items-start gap-2 text-sm">                        
                        <div *ngFor="let member of threatTeam; let i = index;">
                            {{ i+1 }}. {{ member.name }} - {{ member.email }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="w-full flex flex-col items-center gap-2 pb-4"> 

            <div *ngFor="let question of radioQuestions" class="w-full flex flex-col gap-4">
                <div class="w-full flex flex-col items-start text-start">
                    <div class="w-full font-semibold">
                        <p>{{ question.questionText }}</p>
                    </div>
                    <div class="w-full flex items-start gap-2">
                        <div>
                            <input type="radio" [id]="question.id + '_yes'" [value]="yesNo.Yes" class="hidden peer"
                                   [formControlName]="question.formControlName">
                            <label [for]="question.id + '_yes'"
                                   class="inline-flex items-center justify-center w-full px-2 py-1 text-sm font-medium text-center hover:text-gray-900 bg-gray-50 border rounded cursor-pointer text-gray-500 border-gray-300 peer-checked:border-blue-700 peer-checked:bg-blue-50 peer-checked:text-blue-700 hover:bg-gray-50">
                                Yes
                            </label>
                        </div>
                        <div>
                            <input type="radio" [id]="question.id + '_no'" [value]="yesNo.No" class="hidden peer"
                                   [formControlName]="question.formControlName">
                            <label [for]="question.id + '_no'"
                                   class="inline-flex items-center justify-center w-full px-2 py-1 text-sm font-medium text-center hover:text-gray-900 bg-gray-50 border rounded cursor-pointer text-gray-500 border-gray-300 peer-checked:border-blue-700 peer-checked:bg-blue-50 peer-checked:text-blue-700 hover:bg-gray-50">
                                No
                            </label>
                        </div>
                    </div>            
                </div>
            </div>
            <div class="w-full flex flex-col items-start text-start" *ngFor="let question of questionList">
                <div class="w-full font-semibold">
                    <p>{{ question.question }}</p>
                </div>
                <div class="w-full flex flex-col items-center">
                    <textarea 
                        [formControlName]="question.formControlName"
                        rows="3"
                        class="block p-2 w-full text-sm text-gray-900 bg-gray-50 rounded border border-gray-300"
                        placeholder="Type here"
                    ></textarea>
                </div>
            </div>
            <div class="w-full flex flex-col items-start text-start">
                <div class="w-full font-semibold">
                    <p>{{ checkboxQuestion.question }}</p>
                </div>
                <div class="w-full flex flex-col items-start gap-2">
                    <div class="flex items-center" *ngFor="let answer of checkboxQuestion.answers">
                        <input 
                        [id]="checkboxQuestion.formControlName + '_' + answer"
                        type="checkbox"
                        [checked]="threatAssessInfoForm.get(checkboxQuestion.formControlName)?.value.includes(answer)"
                        (change)="onCheckboxChange($event, checkboxQuestion.formControlName, answer)"
                        class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 focus:ring-2">
                        <label [for]="checkboxQuestion.formControlName + '_' + answer" class="ml-2 text-sm font-medium text-gray-900">{{ answer }}</label>
                    </div>
                </div>
            </div>   
            <div *ngIf="this.threatAssessInfoForm.get('send_to')?.value.includes('Other')" class="w-full flex flex-col items-start text-start">
                <div class="font-semibold">
                    <p>Please list where other copies are sent. *</p>
                </div>
                <div class="w-full flex flex-col items-center">
                    <input 
                        type="text"
                        formControlName="send_to_other"
                        class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded block w-full p-2"
                        placeholder="Your Full Name..."
                    >
                </div>
            </div>
        </div>
        <div class="w-full flex flex-row gap-2 items-center justify-end">
            <button
                type="submit"
                class="w-20 flex items-center justify-center px-4 py-1.5 rounded-md border bg-gradient-to-b oswald-font text-white"
                [ngClass]="{
                    'border-nside-gray-100 from-nside-gray-100 to-nside-gray-200 cursor-not-allowed': this.threatAssessInfoForm.invalid,
                    'border-nside-orange-100 from-nside-orange-300 to-nside-orange-400 hover:bg-gradient-to-b hover:from-nside-orange-100 hover:to-nside-orange-200': this.threatAssessInfoForm.valid
                }"
                [disabled]="this.threatAssessInfoForm.invalid"
            >
                Save
            </button>
        </div>
    </div>
</form>

<div *ngIf="loading">
    <spinner></spinner>
</div>